import { Clock, FileText, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useGetAllInvestigations } from '@/application/services/investigation.service'
import { useGetLeadGroups } from '@/application/services/lead.service'
import { StatCard } from './StatCard'

/**
 * Top-of-dashboard KPI grid: 4 stat cards summarising investigations,
 * leads, recent activity and unique submitters. Owns its own data fetching.
 */
export function StatsSection() {
  const { t } = useTranslation()
  const { data: investigations } = useGetAllInvestigations()
  const { data: leadGroups } = useGetLeadGroups()

  const totalInvestigations = investigations?.length || 0
  const allLeads = leadGroups?.flatMap((group) => group.leads) || []
  const recentLeadsCount = Math.min(allLeads.length, 5)
  const uniqueSubmitters = new Set(allLeads.map((lead) => lead.submitterUsername)).size

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <StatCard
        title={t('admin.dash_stat_inv_title')}
        value={totalInvestigations}
        icon={FileText}
        description={t('admin.dash_stat_inv_desc')}
        href="/manage/investigations"
      />
      <StatCard
        title={t('admin.dash_stat_activity_title')}
        value={recentLeadsCount}
        icon={Clock}
        description={t('admin.dash_stat_activity_desc')}
      />
      <StatCard
        title={t('admin.dash_stat_submitters_title')}
        value={uniqueSubmitters}
        icon={Users}
        description={t('admin.dash_stat_submitters_desc')}
      />
    </div>
  )
}
